<template>
  <div>
    <div @click="goToPage(node)" class="toc-item">{{title}}</div>
    <ol class="toc-children">
      <slot v-if="!autoHide || isDescendantActive">
        <li v-for="(node, i) in children" :key="i">        
          <TocItem          
            :children="node.children"
            :title="node.title"
            v-bind="{node, metadata, onCurrentPageChanged}"
          >
          </TocItem>
        </li>
      </slot>
    </ol>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import TocItem from './TocItem';
  
  export default {
    name: 'TocItem',
    components: {
      TocItem
    },
    props: [
      'title',
      'children',
      'node',
      'autoHide',
      'currentPage',
      'metadata',
      'onCurrentPageChanged'
    ],
    data: function () {
      var t = this;

      return {
      }
    },
    computed: {
      isDescendantActive() {
        var t = this;
        var descendantActive = false;        
        _.each(t.children, function(child) {
          if (child.pageRange && t.currentPage.oneBasedIndex >= child.pageRange[0] && t.currentPage.oneBasedIndex <= child.pageRange[1]) {
            descendantActive = true;
            return false;
          }
        });
        return descendantActive;
      }
    },
    methods: {
      goToPage: function (node) {
        var page;
        if (node && node.pageRange) {
          // epub
          page = node.pageRange[0];
        } else if (node && node.page){
          // pdf
          page = node.page;
        }        
        if (page <= 0) {
          page = 1;
        }
        this.onCurrentPageChanged(page, "TOC");
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.toc-item {
  cursor: pointer;
  color: $primary-color;
  text-decoration: underline;
  // padding: 5px 0;
}

ol, li {
  margin: -10px;
  padding: -10px;
}

.toc-children{
  text-align: left;
}

.header {
  background-color: $lightest-bg-color;
  display: table;
  width: 350px;
  padding: 15px 30px 10px 15px;
  border-bottom: 1px solid $background-color-darker3;

  .toc-title {
    display: table-cell;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content-hide {
    display: table-cell;
    width: 100px;
  }
}
</style>


